/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, {useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useIntl} from 'react-intl'

const API_URL = process.env.REACT_APP_API_URL || 'api'

type Props = {
  className: string
  iconPath: string
  iconColor: string
  title: string
  total?: string
  color?: string
  route?: string
}

const CardSystemWidgetContract: React.FC<Props> = ({
  className,
  title,
  color,
  route,
  iconPath,
  iconColor,
}) => {
  let css = 'fw-semibold fs-7' + (color ? ' ' + color : '')
  const [total, setTotal] = useState('')
  const intl = useIntl()

  if (route) getReports()
  async function getReports() {
    await axios
      .get(API_URL + '/sga/v1/' + route)
      .then((response) => {
        setTotal(response.data.datasets.values[0])
      })
      .catch((error) => {
        setTotal('Erro')
      })
  }

  return (
    <div
      className={`card ${className} 
          `}
    >
      {/* begin::Body */}
      <div className='container p-0'>
        {total ? (
          <div className='row'>
            <div className=''>
              <span className='text-center fw-bolder fs-4'>
                <KTSVG path={iconPath} className={`svg-icon svg-icon-2hx ${iconColor} m-2`} />
                {total}
              </span>
            </div>
            <div>
              <span className='text-center fw-bolder fs-4'>
                <a href='#' className={`  ${css}`}>
                  {title}
                </a>
              </span>
            </div>
          </div>
        ) : (
          <>
            <img
              width='25%'
              height='25%'
              alt='Orbit'
              src={toAbsoluteUrl('/media/logos/globo.gif')}
            />
            <br />
            <span className='fs-8'>{intl.formatMessage({id: 'AUTH.PLEASEWAIT'})}</span>{' '}
          </>
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidgetContract}
